import React from 'react';
import { motion } from 'framer-motion';
import supabase from '../supabase/supabase';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Dashboard = ({ user, subscription, profile }) => {
  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };

  const displayName = profile?.first_name || user.email?.split('@')[0] || 'User';
  const fullName = profile?.first_name && profile?.last_name 
    ? `${profile.first_name} ${profile.last_name}`
    : displayName;

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-slate-800/30 p-4 rounded-xl border border-slate-700/30 backdrop-blur-sm"
    >
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
            <span className="text-white font-semibold">
              {(profile?.first_name || user.email || '').charAt(0).toUpperCase()}
            </span>
          </div>
          <div>
            <p className="text-white font-medium">{fullName}</p>
            <p className="text-slate-400 text-sm">
              {subscription.plan === 'monthly' ? 'Monthly' : 'Yearly'} Plan • Active
            </p>
          </div>
        </div>
        
        <button
          onClick={handleSignOut}
          className="px-4 py-2 text-slate-400 hover:text-white hover:bg-slate-700/50 rounded-lg transition duration-200 flex items-center gap-2"
        >
          <SafeIcon icon={FiIcons.FiLogOut} className="w-4 h-4" />
          Sign Out
        </button>
      </div>
    </motion.div>
  );
};

export default Dashboard;